import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * SiteTexts — override dei testi del sito modificabili dall'area admin.
 * `useSiteText(key)` ritorna l'override salvato oppure null
 * (in tal caso il componente mostra il testo originale di design).
 */
const TextsCtx = createContext({});

export function SiteTextsProvider({ children }) {
  const [texts, setTexts] = useState({});
  useEffect(() => {
    api.get("/texts").then((r) => setTexts(r.data?.texts || {})).catch(() => {});
  }, []);
  return <TextsCtx.Provider value={texts}>{children}</TextsCtx.Provider>;
}

export function useSiteText(key) {
  const texts = useContext(TextsCtx);
  return texts[key] || null;
}

/**
 * <T k="chiave">contenuto di default</T>
 * Se esiste un override salvato dall'admin mostra quello (testo semplice),
 * altrimenti il contenuto originale (anche JSX formattato).
 */
export function T({ k, children }) {
  const v = useSiteText(k);
  return v != null ? <>{v}</> : <>{children}</>;
}
